import { render, staticRenderFns } from "./FinancialDetails.vue?vue&type=template&id=2e1f6d73&scoped=true&"
import script from "./FinancialDetails.vue?vue&type=script&lang=js&"
export * from "./FinancialDetails.vue?vue&type=script&lang=js&"
import style0 from "./FinancialDetails.vue?vue&type=style&index=0&id=2e1f6d73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1f6d73",
  null
  
)

export default component.exports